import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import VSNewsSider from './vsNewsSider';
import VSNews from './vsNews';

class VipAndShop extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { vsNewsSiderData, vsNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <VSNewsSider content={vsNewsSiderData} />
                <VSNews content={vsNewsData} />
            </div>
        );
    }
}

export default errorBoundary(VipAndShop);
